import { createContext, useContext } from 'react';
import ar from './ar';
import fr from './fr';
import en from './en';
import type { HomeText } from './types';

export type HomeLang = 'ar' | 'fr' | 'en';

export const HOME_TEXT: Record<HomeLang, HomeText> = { ar, fr, en };

export const HomeTextContext = createContext<HomeText>(ar);

export const useHomeText = () => useContext(HomeTextContext);
